/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedOmit } from '@client/new/helpers/types';
import { Input, InputProps } from '@design-system/components/input/input';
import { faDollar, faPercent } from '@fortawesome/pro-regular-svg-icons';
import { Col } from '@design-system/components/grid/grid';
import { ErrorMessage } from '@client/new/components/Label';
import { forwardRef } from 'react';

type NumberInputProps = TypedOmit<InputProps, 'value' | 'onChange'> & {
  width?: number;
  value: number | null | undefined;
  onChange: (v: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: number;
};

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, defaultValue, onChange, width, ...p }, ref) => (
    <Col style={width ? { width: width + 'px' } : {}}>
      <Input
        value={value === null ? defaultValue : value + ''}
        ref={ref}
        onChange={(e) => {
          let inputValue = e.target.value;
          inputValue = inputValue.replace(',', '.');
          const target = { name: p.name, value: defaultValue || 0 };
          if (inputValue === '') onChange({ target } as any);
          else {
            const parsedValue = parseFloat(inputValue);
            target.value = parsedValue;
            if (!isNaN(parsedValue)) onChange({ target } as any);
          }
        }}
        type="number"
        hideError
        {...p}
      />
      <div style={{ marginTop: '0' }}>
        <ErrorMessage content={p.error} />
      </div>
    </Col>
  ),
);

export const PercentInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ ...p }, ref) => (
    <NumberInput
      step="0.01"
      max={100}
      min={0}
      endIcon={{ icon: faPercent }}
      ref={ref}
      {...p}
    />
  ),
);

export const DollarsInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ ...p }, ref) => (
    <NumberInput
      step="0.01"
      {...p}
      min={0}
      startIcon={{ icon: faDollar }}
      ref={ref}
    />
  ),
);
